// extracted by mini-css-extract-plugin
export default {"desktopOnly":"DesktopOnly_desktopOnly__hSKQ3"};